import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueParticles from 'vue-particles'
/*import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'*/

import 'babel-polyfill'
import 'es6-promise/auto'
import vuescroll from 'vuescroll'
import store from './store/'
import 'vuescroll/dist/vuescroll.css'
import filters from './service/filters'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/main.scss'
import './assets/icon/iconfont.css'
import { exTableComponent , exTableColComponent} from './components/table/index'
import common from './service/common'
import basics from '@/components/basics/'

Vue.config.productionTip = false;

Vue.use(exTableComponent);
Vue.use(exTableColComponent);

Vue.use(ElementUI);
Vue.use(VueParticles);
// Vue.use(VueQuillEditor);

Vue.use(vuescroll);
Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#C2D0E4'
  }
};
Vue.prototype.$download = function (name,data){
  const fileName = name + '.xls';
  const elink = document.createElement('a');
  elink.download = fileName;
  // elink.style.display = 'none';
  elink.href = URL.createObjectURL(data);
  // document.body.appendChild(elink);
  elink.click();
  // URL.revokeObjectURL(elink.href);
  // document.body.removeChild(elink);
}

Object.keys(common).forEach(key => {
  Vue.prototype[key] = common[key]
})

Object.keys(filters).forEach(key => {
  Vue.filter(key , filters[key])
});

Object.keys(basics).forEach(key => {
  Vue.component(key , basics[key])
})


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js